/** Phone breakpoint — aligned with `src/mobile/featureFlag.ts` (767px). */
export const VISUAL_VIEWPORT_PHONE_MAX = 767;

/** Tablet upper bound (inclusive). Desktop starts at 1024px. */
export const VISUAL_VIEWPORT_TABLET_MAX = 1023;

export type VisualViewport = 'phone' | 'tablet' | 'desktop';

export function resolveVisualViewport(width: number): VisualViewport {
  if (width <= VISUAL_VIEWPORT_PHONE_MAX) return 'phone';
  if (width <= VISUAL_VIEWPORT_TABLET_MAX) return 'tablet';
  return 'desktop';
}
